<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="visible"
    width="700px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    @close="handleClose"
  >
    <el-form
      ref="formRef"
      :model="localFormData"  
      :rules="formRules"
      label-width="120px"
      label-position="right"
      class="checkin-form"
    >
      <!-- 第一行：基础信息 -->
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="登记日期：" prop="registerDate">
            <el-date-picker
              v-model="localFormData.registerDate" 
              type="date"
              placeholder="请选择登记日期"
              style="width: 100%"
              :disabled="isEdit"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="招商状态：" prop="status">
            <el-select
              v-model="localFormData.status"  
              placeholder="请选择招商状态"
              style="width: 100%"
              clearable
            >
              <el-option label="已签约" value="已签约"></el-option>
              <el-option label="待签约" value="待签约"></el-option>
              <el-option label="沟通中" value="沟通中"></el-option>
              <el-option label="已放弃" value="已放弃"></el-option>
              <el-option label="暂停" value="暂停"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 第二行：企业基本信息 -->
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="企业名称：" prop="enterpriseName">
            <el-input
              v-model="localFormData.enterpriseName" 
              placeholder="请输入企业名称"
              maxlength="100"
              show-word-limit
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="行业类别：" prop="industryType">
            <el-select
              v-model="localFormData.industryType"  
              placeholder="请选择行业类别"
              style="width: 100%"
              clearable
            >
                <el-option label="人工智能" value="人工智能"></el-option>
                <el-option label="软件（数字）" value="软件（数字）"></el-option>
                <el-option label="新能源" value="新能源"></el-option>
                <el-option label="新材料" value="新材料"></el-option>
                <el-option label="资本金融" value="资本金融"></el-option>
                <el-option label="咨询服务" value="咨询服务"></el-option>
                <el-option label="其他行业" value="其他行业"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 第三行：区域和租金政策 -->
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="归属区域：" prop="belongArea">
            <el-input
              v-model="localFormData.belongArea"  
              placeholder="请详细输入归属区域（如：南区）"
              maxlength="200"
              show-word-limit
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="租金政策：" prop="rentPolicy">
            <el-select
              v-model="localFormData.rentPolicy"  
              placeholder="请选择租金政策"
              style="width: 100%"
              clearable
            >
              <el-option label="实缴租金" value="实缴租金"></el-option>
              <el-option label="租金优惠" value="租金优惠"></el-option>
              <el-option label="合作联营" value="合作联营"></el-option>
              <el-option label="其他" value="其他"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 第四行：五年规划数据 -->
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="五年营收规划：" prop="fiveYearIncomePlan">
            <el-input
              v-model.number="localFormData.fiveYearIncomePlan"  
              placeholder="请输入金额（万元）"
              type="number"
              min="0"
              step="0.01"
              suffix="万元"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="五年税收规划：" prop="fiveYearTaxPlan">
            <el-input
              v-model.number="localFormData.fiveYearTaxPlan" 
              placeholder="请输入金额（万元）"
              type="number"
              min="0"
              step="0.01"
              suffix="万元"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="五年总规划：" prop="fiveYearTotalPlan">
            <el-input
              v-model.number="localFormData.fiveYearTotalPlan" 
              placeholder="请输入金额（万元）"
              type="number"
              min="0"
              step="0.01"
              suffix="万元"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 第五行：场地需求（需求面积+办公人数） -->
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="需求面积：" prop="demandArea">
            <el-input
              v-model.number="localFormData.demandArea" 
              placeholder="请输入面积（㎡）"
              type="number"
              min="0"
              step="0.1"
              suffix="㎡"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="办公人数：" prop="officePeopleNum">
            <el-input
              v-model.number="localFormData.officePeopleNum"  
              placeholder="请输入人数"
              type="number"
              min="0"
              step="1"
              suffix="人"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 第六行：所选位置（单独一行） -->
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="所选位置：" prop="selectedPosition">
            <el-input
              v-model="localFormData.selectedPosition"  
              placeholder="请详细输入所选位置（如：科创中心3号楼2层201室）"
              maxlength="200"
              show-word-limit
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 第七行：联系人信息 -->
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="企业联系人：" prop="enterpriseLinkman">
            <el-input
              v-model="localFormData.enterpriseLinkman"  
              placeholder="请输入联系人姓名"
              maxlength="50"
              show-word-limit
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系方式：" prop="contactWay">
            <el-input
              v-model="localFormData.contactWay"  
              placeholder="请输入联系电话/微信"
              maxlength="50"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 第八行：招商负责人和进展 -->
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="招商负责人：" prop="principal">
            <el-input
              v-model="localFormData.principal"  
              placeholder="请输入招商负责人"
              maxlength="50"
              show-word-limit
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="进展情况：" prop="progress">
            <el-input
              v-model="localFormData.progress" 
              placeholder="请输入项目进展情况"
              maxlength="200"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 备注信息 -->
      <el-form-item label="备注信息：" prop="remark">
        <el-input
          v-model="localFormData.remark" 
          type="textarea"
          placeholder="请输入备注信息（选填）"
          :rows="4"
          maxlength="500"
          show-word-limit
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitLoading">
        {{ isEdit ? '更新' : '保存' }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "OfficeCheckinDialog",
  props: {
    // 是否显示对话框
    visible: {
      type: Boolean,
      default: false
    },
    // 表单数据
    formData: {
      type: Object,
      default: () => ({})
    },
    // 是否为编辑模式
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 表单校验规则
      formRules: {
        registerDate: [
          { required: !this.isEdit, message: '请选择登记日期', trigger: 'change' }
        ],
        status: [
          { required: true, message: '请选择招商状态', trigger: 'change' }
        ],
        enterpriseName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' },
          { min: 2, max: 100, message: '企业名称长度在 2 到 100 个字符', trigger: 'blur' }
        ],
        industryType: [
          { required: true, message: '请选择行业类别', trigger: 'change' }
        ],
        belongArea: [
          { required: true, message: '请输入归属区域', trigger: 'blur' },
          { min: 2, max: 200, message: '归属区域长度在 2 到 200 个字符', trigger: 'blur' }
        ],
        demandArea: [
          { required: true, message: '请输入需求面积', trigger: 'blur' },
          { type: 'number', min: 0, message: '需求面积必须大于等于0', trigger: 'blur' }
        ],
        selectedPosition: [
          { required: true, message: '请输入所选位置', trigger: 'blur' },
          { min: 2, max: 200, message: '所选位置长度在 2 到 200 个字符', trigger: 'blur' }
        ],
        enterpriseLinkman: [
          { required: true, message: '请输入企业联系人', trigger: 'blur' },
          { min: 2, max: 50, message: '联系人长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        contactWay: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          { min: 2, max: 50, message: '联系方式长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        principal: [
          { required: true, message: '请输入招商负责人', trigger: 'blur' },
          { min: 2, max: 50, message: '负责人长度在 2 到 50 个字符', trigger: 'blur' }
        ]
      },
      // 提交加载状态
      submitLoading: false,
      // 本地表单数据副本（避免直接修改props）
      localFormData: {},
      // 标记是否是首次加载（用于控制日期默认值）
      isFirstLoad: true
    };
  },
  computed: {
    // 对话框标题
    dialogTitle() {
      return this.isEdit ? '编辑招商信息' : '新增招商信息';
    }
  },
  watch: {
    // 监听对话框显示状态，确保新增时默认日期生效
    visible(newVal) {
      if (newVal && !this.isEdit) {
        // 打开对话框且为新增模式时，设置默认日期
        this.setDefaultDate();
      } else if (!newVal) {
        // 关闭对话框时重置状态
        this.resetForm();
        this.isFirstLoad = true;
      }
    },
    // 监听props中的formData变化，同步到本地
    formData: {
      handler(newVal) {
        // 深拷贝，避免修改原数据
        this.localFormData = JSON.parse(JSON.stringify(newVal));
        
        // 数据类型转换：确保数字字段为number类型
        const numberFields = [
          'fiveYearIncomePlan', 'fiveYearTaxPlan', 'fiveYearTotalPlan',
          'demandArea', 'officePeopleNum'
        ];
        numberFields.forEach(field => {
          if (this.localFormData[field] !== undefined && this.localFormData[field] !== null) {
            this.localFormData[field] = Number(this.localFormData[field]) || 0;
          } else {
            this.localFormData[field] = 0;
          }
        });

        // 新增模式且首次加载、无日期值时，补充默认日期
        if (this.isFirstLoad && !this.isEdit && !this.localFormData.registerDate) {
          this.setDefaultDate();
        }
        this.isFirstLoad = false;
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    /**
     * 设置默认日期为当天
     */
    setDefaultDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      // 仅在没有日期值时赋值，避免覆盖用户已选择的日期
      if (!this.localFormData.registerDate) {
        this.localFormData.registerDate = `${year}-${month}-${day}`;
      }
    },
    /**
     * 格式化日期为YYYY-MM-DD（保留原有方法兼容其他逻辑）
     */
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.submitLoading = false;
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields();
      }
      // 清空本地表单数据
      this.localFormData = {};
    },
    /**
     * 关闭对话框
     */
    handleClose() {
      this.$emit('close');
    },
    /**
     * 提交表单
     */
    handleSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          // 提交前的数值处理（确保数字类型正确）
          const submitData = {
            ...this.localFormData,
            fiveYearIncomePlan: Number(this.localFormData.fiveYearIncomePlan) || 0,
            fiveYearTaxPlan: Number(this.localFormData.fiveYearTaxPlan) || 0,
            fiveYearTotalPlan: Number(this.localFormData.fiveYearTotalPlan) || 0,
            demandArea: Number(this.localFormData.demandArea) || 0,
            officePeopleNum: Number(this.localFormData.officePeopleNum) || 0
          };
          // 触发父组件的保存事件
          this.$emit('save', submitData);
          // 延迟关闭加载状态，避免视觉闪烁
          setTimeout(() => {
            this.submitLoading = false;
          }, 500);
        } else {
          this.$message.warning('请完善必填信息后提交');
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.checkin-form {
  padding: 10px 0;
}

.el-form-item {
  margin-bottom: 18px;
}

/* 输入框样式优化 */
.el-input-number .el-input__inner {
  text-align: left !important;
}

/* 所选位置输入框样式优化 */
.el-form-item:nth-child(9) .el-input {
  width: 100%;
}

/* 对话框底部按钮样式 */
.dialog-footer {
  text-align: right;
}

/* 适配小屏幕 */
@media screen and (max-width: 768px) {
  .el-dialog {
    width: 95% !important;
  }
  
  .el-form-item {
    margin-bottom: 15px;
  }
  
  .el-form-item__label {
    width: 100px !important;
  }
}
</style>